import React from "react";

const NextArrowIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="36"
    height="12"
    viewBox="0 0 36 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="30.3438"
      y="11.629"
      width="1"
      height="8"
      rx="0.5"
      transform="rotate(-135 30.3438 11.629)"
      fill="#212326"
    />
    <rect
      x="29.6368"
      y="1.02156"
      width="1"
      height="8"
      rx="0.5"
      transform="rotate(-45 29.6368 1.02156)"
      fill="#212326"
    />
    <rect
      x="35.0001"
      y="5.31453"
      width="1"
      height="35"
      rx="0.5"
      transform="rotate(90 35.0001 5.31453)"
      fill="#212326"
    />
  </svg>
);

export default NextArrowIcon;
